import { z } from 'zod';

/** Stable error codes returned by the API. Clients branch on `code`, never on `message`. */
export const API_ERROR_CODES = [
  'VALIDATION_FAILED',
  'UNAUTHENTICATED',
  'INVALID_CREDENTIALS',
  'FORBIDDEN',
  'NOT_FOUND',
  'CONFLICT',
  'VERSION_CONFLICT',
  'IDEMPOTENCY_KEY_REQUIRED',
  'IDEMPOTENCY_KEY_REUSED',
  'IDEMPOTENCY_IN_PROGRESS',
  'CSRF_REJECTED',
  'RATE_LIMITED',
  'PAYLOAD_TOO_LARGE',
  // SaaS (ADR-0030)
  'MODULE_NOT_IN_PLAN',
  'PLAN_LIMIT_REACHED',
  'SUBSCRIPTION_READ_ONLY',
  'TENANT_SUSPENDED',
  /** Password accepted; the account has TOTP enabled and `totp_code` is missing or wrong (ADR-0031). */
  'MFA_REQUIRED',
  'MONEY_OVERFLOW',
  'CURRENCY_MISMATCH',
  'INSUFFICIENT_STOCK',
  'INVALID_STATE_TRANSITION',
  'APPROVAL_REQUIRED',
  'BUDGET_EXCEEDED',
  'DUPLICATE_INVOICE',
  'MATCH_TOLERANCE_EXCEEDED',
  'LOT_ON_HOLD',
  /** Receipt lines of a must-inspect category are not inspected yet (ADR-0037). */
  'INSPECTION_REQUIRED',
  'EXPIRED_LOT',
  /** A payment-provider callback failed signature or replay-window verification. */
  'WEBHOOK_REJECTED',
  /** The tenant's database (shard) is not reachable from this Worker (ADR-0035). */
  'SERVICE_UNAVAILABLE',
  'INTERNAL_ERROR',
] as const;

export type ApiErrorCode = (typeof API_ERROR_CODES)[number];

export const apiErrorSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    request_id: z.string(),
    details: z.record(z.string(), z.unknown()).default({}),
  }),
});

export type ApiErrorBody = z.infer<typeof apiErrorSchema>;
